var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lamp",class:{ online: _vm.online },style:({ 'background-color': _vm.online ? 'green' : 'red' })})}
var staticRenderFns = []

export { render, staticRenderFns }